/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Box,
  //Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  // FormControlLabel,
  IconButton,
  Switch,
  // Slider,
  // Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PieChartIcon from "@mui/icons-material/PieChart";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import { CacheContext } from "../Context/cacheContext";
import { ChangeEvent, SyntheticEvent, useContext, useState } from "react";
import { Vocabulary } from "../Utils/Vocabulary";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import style from "../Styles/filters.module.css";
import TuneIcon from "@mui/icons-material/Tune";
import { isMobile } from "../Utils/utils";
import { PillsProps } from "./MainDashboard";
import { VehiclesTab } from "../Utils/autocompleteEnum";
import { GenericModel, StatusModel } from "../Models/Models";
import SellIcon from "@mui/icons-material/Sell";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation } from "react-router-dom";
import VehicleDetailsFilterCollapsible from "./Generic/VehicleDetailsFilterCollapsible";
import {
  WEBSITE_INTEGRATIONS,
  WebsiteModel,
} from "../Utils/websiteIntegrations";

const VehicleStatus = {
  NotReceived: Vocabulary.received,
  Unsold: Vocabulary.preparationDelays,
} as const;

const VehicleStatusEN = {
  NotReceived: "NotReceived",
  Unsold: "Unsold",
  UnsoldNotReceived: "Unsold, NotReceived",
  TvaRecovered: "1",
  TvaToBeRecovered: "0",
} as const;

type VehicleStatusProps = {
  users: any;
  data: PillsProps;
  handleSliderChange: (event: any, newValue: any) => void;
  handleMinInputChangeURL: (event: any) => void;
  handleMaxInputChangeURL: (event: any) => void;
  onChangeTextField: (event: any, newValue: any, name: string) => void;
  changeStatusError: (statusError: string) => void;
  changeTvaRecovered: (tvaRecovered: string) => void;
  handleAccordion: (open: boolean) => void;
  setShowIncompleteVehicles: (
    event: ChangeEvent<HTMLInputElement>,
    newValue: boolean,
  ) => void;
  statusesForFilters?: Array<StatusModel>;
  sellingStatuses?: Array<StatusModel>;
  distinctLocationIds?: Array<number | string>;
};
export default function VehicleSlider(props: VehicleStatusProps) {
  const {
    users,
    data,
    // handleSliderChange,
    handleMinInputChangeURL,
    handleMaxInputChangeURL,
    onChangeTextField,
    changeStatusError,
    changeTvaRecovered,
    handleAccordion,
    setShowIncompleteVehicles,
    statusesForFilters,
    sellingStatuses,
    distinctLocationIds,
  } = props;
  const cacheContext: any = useContext(CacheContext);
  const location = useLocation(); // Used for VehicleDetailsFilterCollapsible
  const [hideFilters, setHideFilters] = useState(true);
  const [eventForMinPrice, setEventForMinPrice] = useState();
  const [eventForMaxPrice, setEventForMaxPrice] = useState();
  const [minPrice, setMinPrice] = useState(data.minPrice);
  const [maxPrice, setMaxPrice] = useState(data.maxPrice);

  function handleChangeMinPrice(event: any) {
    if (eventForMinPrice && event?.key === "Enter")
      handleMinInputChangeURL(eventForMinPrice);
    if (eventForMinPrice && event?.type === "blur")
      handleMinInputChangeURL(eventForMinPrice);
  }
  function handleChangeMaxPrice(event: any) {
    if (eventForMaxPrice && event.key === "Enter")
      handleMaxInputChangeURL(eventForMaxPrice);
    if (eventForMaxPrice && event?.type === "blur")
      handleMaxInputChangeURL(eventForMaxPrice);
  }

  /**
   * Get the users for filtering depending on the status
   * @returns users for filtering
   */
  const getUsersOptions = (): GenericModel[] => {
    switch (data.status) {
      case VehiclesTab.sold:
        return users.vanzatori;
      case VehiclesTab.reserved:
        return users.useriReservari;
      default:
        return users.useriAchizitie;
    }
  };

  /**
   * Maps filter names to their corresponding cache property names
   */
  const cachePropertyMap: Record<string, string> = {
    brand: "brands",
    model: "models",
    bodyType: "bodyworkTypes",
    gearbox: "gearboxes",
    company: "company",
    locations: "locations",
    vehicleTypes: "vehicleTypes",
    purchaseType: "purchaseType",
    websiteIntegrations: "websiteIntegrations",
  };

  /**
   * @returns values for autocomplete from url
   */
  const getValuesForMultipleAutocomplete = (value: string) => {
    const array: GenericModel[] = [];
    let currentValue = (data as any)?.[value];

    if (!currentValue) return array;

    try {
      // Decode URL-encoded values (e.g., for websiteIntegrations)
      if (currentValue.includes("%")) {
        currentValue = decodeURIComponent(currentValue);
      }
      const ids = JSON.parse(currentValue);
      if (!ids?.length) return array;

      const cache = cacheContext.cache;
      const cacheUsers = getUsersOptions();

      const findAndAdd = (searchArray: any[]) => {
        ids.forEach((id: number) => {
          const found = searchArray?.find((item: any) => item.id == id);
          if (found) array.push(found);
        });
      };

      switch (value) {
        case "statusVehicul":
          findAndAdd(sellingStatuses || []);
          break;
        case "physicalVehicleStatus":
          findAndAdd(statusesForFilters || []);
          break;
        case "users":
          findAndAdd(cacheUsers);
          break;
        case "websiteIntegrations":
          // Website integrations use 'code' instead of 'id'
          ids.forEach((code: string) => {
            const found = WEBSITE_INTEGRATIONS.find(
              (item: WebsiteModel) => item.code === code,
            );
            if (found) array.push(found as any);
          });
          break;
        default: {
          const cacheProperty = cachePropertyMap[value];
          if (cacheProperty && cache[cacheProperty]) {
            findAndAdd(cache[cacheProperty]);
          }
          break;
        }
      }
    } catch {
      return array;
    }

    return array;
  };

  /**
   *
   *
   */
  const handleChangeMultipleAutocomplete = (
    event: SyntheticEvent<Element, Event>,
    newValue: GenericModel[],
    changingValue: string,
  ) => {
    const ids: any[] = [];
    if (newValue) {
      newValue?.forEach((item: any) => {
        // Website integrations use 'code' instead of 'id'
        if (changingValue === "websiteIntegrations") {
          ids.push(item?.code);
        } else {
          ids.push(item?.id);
        }
      });
    }
    onChangeTextField(event, ids, changingValue);
  };

  // /**
  //  *
  //  * @returns
  //  */
  // const latestAddedCarsSort = () => {
  //   return (
  //     <Grid item xs={12} md={12}>
  //       <FormControlLabel
  //         label={
  //           <Typography style={{ fontSize: "1rem" }}>
  //             {Vocabulary.latestCars}
  //           </Typography>
  //         }
  //         control={
  //           <Switch
  //             checked={data?.sortByCreatedAt == "true"}
  //             onChange={(event: ChangeEvent<HTMLInputElement>) => {
  //               //props?.setShowIncompleteVehicles?.(e, e.target.checked); daca se vrea doar la vehicule
  //               onChangeTextField(
  //                 event,
  //                 event?.target.checked,
  //                 "sortByCreatedAt"
  //               );
  //             }}
  //           />
  //         }
  //       />
  //     </Grid>
  //   );
  // };

  /**
   *
   */
  const showCarsWithNegativeProfit = () => {
    return (
      <Grid item xs={12} md={12}>
        <FormControlLabel
          label={
            <Typography style={{ fontSize: "1rem" }}>
              {Vocabulary.vehiclesWithNegativeProfit}
            </Typography>
          }
          control={
            <Switch
              checked={data?.showNegativeProfit == "true"}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                //props?.setShowIncompleteVehicles?.(e, e.target.checked); daca se vrea doar la vehicule
                onChangeTextField(
                  event,
                  event?.target.checked,
                  "showNegativeProfit",
                );
              }}
            />
          }
        />
      </Grid>
    );
  };

  return (
    <div className={hideFilters ? style.container : style.containerHide}>
      <div className={hideFilters ? style.filters : style.filtersHide}>
        {/* Filters Title */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <TuneIcon sx={{ color: "#4d5e80", mr: 1, fontSize: "1.3rem" }} />
          <Typography
            sx={{
              fontWeight: 600,
              color: "#4d5e80",
              fontSize: "1.1rem",
            }}
          >
            {Vocabulary.filters}
          </Typography>
        </Box>

        {/* Vehicle Details Collapsible Section */}
        <VehicleDetailsFilterCollapsible
          data={data}
          cacheContext={cacheContext}
          location={location}
          getValuesForMultipleAutocomplete={getValuesForMultipleAutocomplete}
          handleChangeMultipleAutocomplete={handleChangeMultipleAutocomplete}
          handleAccordion={handleAccordion}
        />

        {data?.status != VehiclesTab.sold &&
          data?.status != VehiclesTab.partialVehicles && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
              <Autocomplete
                id="statusVehicul"
                freeSolo={false}
                fullWidth
                disablePortal
                multiple
                getOptionLabel={(option: any) => option.nume}
                size="small"
                value={getValuesForMultipleAutocomplete("statusVehicul") ?? []}
                options={sellingStatuses ?? []}
                onChange={(event: any, newValue: any) => {
                  handleChangeMultipleAutocomplete(
                    event,
                    newValue,
                    "statusVehicul",
                  );
                  handleAccordion(false);
                }}
                sx={{ maxWidth: "90%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status Vanzare Vehicul"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Box>
          )}
        {data?.status != VehiclesTab.sold &&
          data?.status != VehiclesTab.partialVehicles &&
          statusesForFilters?.length != 0 && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
              <Autocomplete
                id="physicalVehicleStatus"
                freeSolo={false}
                fullWidth
                disablePortal
                multiple
                getOptionLabel={(option: any) => option.nume}
                size="small"
                value={
                  getValuesForMultipleAutocomplete("physicalVehicleStatus") ??
                  []
                }
                options={statusesForFilters ?? []}
                onChange={(event: any, newValue: any) => {
                  handleChangeMultipleAutocomplete(
                    event,
                    newValue,
                    "physicalVehicleStatus",
                  );
                  handleAccordion(false);
                }}
                sx={{ maxWidth: "90%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status Fizic Vehicul"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Box>
          )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PeopleAltIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
          <Autocomplete
            id="users"
            multiple
            freeSolo={false}
            disablePortal
            getOptionLabel={(option: any) => option.nume}
            size="small"
            fullWidth
            options={getUsersOptions()}
            value={getValuesForMultipleAutocomplete("users")}
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "users");
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Utilizatori"
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
          <TaxiAlertIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
          <Autocomplete
            id="company"
            multiple
            freeSolo={false}
            fullWidth
            disablePortal
            getOptionLabel={(option: any) => option.nume_firma}
            size="small"
            options={cacheContext.cache.company}
            value={getValuesForMultipleAutocomplete("company")}
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "company");
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Firme"
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LocationCityIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
          <Autocomplete
            id="locations"
            multiple
            disablePortal
            freeSolo={false}
            getOptionLabel={(option: any) => option.nume}
            size="small"
            value={getValuesForMultipleAutocomplete("locations")}
            options={
              distinctLocationIds && distinctLocationIds.length > 0
                ? cacheContext.cache.locations?.filter((location: any) =>
                    distinctLocationIds.includes(location.id),
                  ) || []
                : cacheContext.cache.locations
            }
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "locations");
              handleAccordion(false);
            }}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={Vocabulary.administrativeLocation}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PieChartIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
          <Autocomplete
            id="vehicleTypes"
            multiple
            freeSolo={false}
            disablePortal
            getOptionLabel={(option: any) => option.nume}
            size="small"
            options={cacheContext.cache.vehicleTypes}
            onChange={(
              event: SyntheticEvent<Element, Event>,
              newValue: any[],
            ) => {
              handleChangeMultipleAutocomplete(event, newValue, "vehicleTypes");
              handleAccordion(false);
            }}
            sx={{ width: "100%" }}
            value={getValuesForMultipleAutocomplete("vehicleTypes")}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tip vehicul"
                variant="outlined"
                size="small"
              />
            )}
          ></Autocomplete>
        </Box>

        {data?.status != VehiclesTab.intermediated && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SellIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
            <Autocomplete
              id="purchaseType"
              multiple
              freeSolo={false}
              disablePortal
              getOptionLabel={(option: any) => option.nume}
              size="small"
              options={cacheContext.cache.purchaseType}
              onChange={(
                event: SyntheticEvent<Element, Event>,
                newValue: any[],
              ) => {
                handleChangeMultipleAutocomplete(
                  event,
                  newValue,
                  "purchaseType",
                );
                handleAccordion(false);
              }}
              sx={{ width: "100%" }}
              value={getValuesForMultipleAutocomplete("purchaseType")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={Vocabulary.purchaseType}
                  variant="outlined"
                  size="small"
                />
              )}
            ></Autocomplete>
          </Box>
        )}

        {/* Website Integrations Filter */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <VisibilityIcon sx={{ color: "#4d5e80", mr: 1, my: 2 }} />
          <Autocomplete
            id="websiteIntegrations"
            multiple
            freeSolo={false}
            disablePortal
            fullWidth
            getOptionLabel={(option: any) => option.name}
            size="small"
            options={WEBSITE_INTEGRATIONS || []}
            value={
              getValuesForMultipleAutocomplete(
                "websiteIntegrations",
              ) as WebsiteModel[]
            }
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(
                event,
                newValue,
                "websiteIntegrations",
              );
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={Vocabulary.websiteIntegrationsText}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", marginTop: 1.8 }}>
          <EuroSymbolIcon sx={{ color: "#4d5e80", mr: 2, my: 1 }} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <TextField
                value={minPrice
                  ?.toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                size="small"
                onChange={(e: any) => {
                  const numValue = e?.target?.value?.replace(/\s/g, "");
                  setEventForMinPrice(e);
                  setMinPrice(numValue);
                }}
                onBlur={(e: any) => handleChangeMinPrice(e)}
                onKeyUp={(e: any) => {
                  handleChangeMinPrice(e);
                }}
                label="Minim"
                style={{ marginLeft: -8 }}
                inputProps={{
                  step: 1000,
                  min: 0,
                  type: "text",
                }}
              />
              <TextField
                value={maxPrice
                  ?.toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                size="small"
                onChange={(e: any) => {
                  const numValue = e?.target?.value?.replace(/\s/g, "");
                  setEventForMaxPrice(e);
                  setMaxPrice(numValue);
                }}
                onKeyUp={(e: any) => {
                  handleChangeMaxPrice(e);
                }}
                onBlur={(e: any) => handleChangeMaxPrice(e)}
                label="Maxim"
                inputProps={{
                  step: 1000,
                  min: 0,
                  type: "text",
                }}
              />
            </div>
          </div>
        </Box>

        <Grid
          container
          spacing={2}
          style={{ padding: "5px", marginTop: "10px" }}
        >
          <Grid item xs={12} md={12}>
            <FormControlLabel
              label={
                <Typography style={{ fontSize: "1rem" }}>
                  {Vocabulary.incompleteVehicles}
                </Typography>
              }
              control={
                <Switch
                  checked={data?.showIncompleteVehicles}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setShowIncompleteVehicles(e, e.target.checked);
                  }}
                />
              }
            />
          </Grid>
          {/* {latestAddedCarsSort()} */}
          {data?.status === VehiclesTab.sold && showCarsWithNegativeProfit()}
        </Grid>
        {
          <div>
            <div
              style={{
                border: "1px solid #0000001f",
                borderRadius: 10,
                marginTop: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor:
                    data?.tvaRecovered?.toString() ===
                    VehicleStatusEN.TvaToBeRecovered
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.tvaRecovered?.toString() ===
                  VehicleStatusEN.TvaToBeRecovered
                    ? changeTvaRecovered("null")
                    : changeTvaRecovered(VehicleStatusEN.TvaToBeRecovered)
                }
              >
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: 30,
                      width: 30,
                      backgroundColor: "#7a7a7a63",
                      margin: 10,
                      borderRadius: 10,
                    }}
                  ></div>
                  <p
                    style={{
                      margin: 13,
                      verticalAlign: "center",
                      color: "#4d5e80",
                    }}
                  >
                    {"TVA recuperat"}
                  </p>
                </div>
              </div>

              <Divider />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor:
                    data?.statusError === VehicleStatusEN.Unsold
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.statusError === VehicleStatusEN.Unsold
                    ? changeStatusError("null")
                    : changeStatusError(VehicleStatusEN.Unsold)
                }
              >
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: 30,
                      width: 30,
                      backgroundColor: "#ffccbb63",
                      margin: 10,
                      borderRadius: 10,
                    }}
                  ></div>
                  <p
                    style={{
                      margin: 13,
                      verticalAlign: "center",
                      color: "#4d5e80",
                    }}
                  >
                    {VehicleStatus.Unsold}
                  </p>
                </div>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  backgroundColor:
                    data?.statusError === VehicleStatusEN.NotReceived
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.statusError === VehicleStatusEN.NotReceived
                    ? changeStatusError("null")
                    : changeStatusError(VehicleStatusEN.NotReceived)
                }
              >
                <div
                  style={{
                    height: 30,
                    width: 30,
                    backgroundColor: "#cc43144d",
                    margin: 10,
                    borderRadius: 10,
                  }}
                ></div>
                <p
                  style={{
                    margin: 13,
                    verticalAlign: "center",
                    color: "#4d5e80",
                  }}
                >
                  {VehicleStatus.NotReceived}
                </p>
              </div>
            </div>
          </div>
        }
      </div>

      <div style={{ position: "absolute", bottom: 10, left: 8 }}>
        {isMobile() ? null : hideFilters ? (
          <Tooltip title="Ascunde filtre">
            <IconButton
              onClick={() => setHideFilters(!hideFilters)}
              style={{ backgroundColor: "#4448", color: "#fff" }}
            >
              <ChevronLeftIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filtre">
            <IconButton
              onClick={() => setHideFilters(!hideFilters)}
              style={{ backgroundColor: "#ff6633", color: "#fff" }}
            >
              <TuneIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
